var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center px-3",class:_vm.alto(),staticStyle:{"margin-top":"5rem"}},[_c('img',{staticClass:"imagen-404",attrs:{"src":require("@/assets/imagenes/mantenimiento.png")}}),_c('h1',[_vm._v("Apartado en mantenimiento")]),_c('h4',{staticClass:"text-muted"},[_vm._v("Estamos trabajando para ofrecerle un mejor servicio")])])
}
var staticRenderFns = []

export { render, staticRenderFns }